<template>
  <form class="page-form" @submit.prevent="handleSubmit">
    <SelectElement
      :value="selectedItem ?? ''"
      :options="options"
      label="title"
      trackBy="id"
      objectKey="item"
      isRequired
      :title="props.type === 'products' ? 'Выберите товар' : 'Выберите услугу'"
      titleClass="medium-18"
      :placeholder="props.type === 'products' ? 'Выберите товар' : 'Выберите услугу'"
      searchable
      :loading="isListLoading"
      @dataChanged="valueUpdate"
    />
    <FormActionBtns
      reversed
      class="page-form__btn-container"
      :isLoading="isLoading"
      :disabled="!selectedItem"
      @cancel="$emit('close')"
    >
      {{ isEditing ? 'Сохранить изменения' : 'Добавить' }}
    </FormActionBtns>
  </form>
</template>

<script lang="ts" src="./HomePageForm.ts"></script>

<style scoped lang="scss" src="./HomePageForm.scss"></style>
